import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBeltSkimmer = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 70,
	height: 98,
	viewBox: "0 0 70.0 98.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 0,
			width: 40,
			height: 25,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 20,
			cy: 12.5,
			rx: 8,
			ry: 8,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 20,
			cy: 90,
			rx: 8,
			ry: 8,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 12.0 12.5 L 12.0 90.0 M 28.0 12.5 L 28.0 90.0 M 70.0 20.0 L 40.0 8.0 L 40.0 16.0 L 70.0 28.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgBeltSkimmer;
